import Vue from 'vue';
import StoreConfiguration from './store-configuration';
import Store from './concepts-store';
import Utils from './utils';
import axios from "axios";

class TreeUtils {

    sortTreeNodesByConf(nodes, configuration, lang) {

        if (nodes && nodes.length) {
            // Sort by concept/individual
            nodes.sort((a, b) => Utils.compareBoolean(a.class, b.class));

            if (configuration?.concepts_arborescence?.ordre) {

                // Find the break point
                const splitPointIndex = nodes.findIndex(x => !x.class);
                const initialKey = 1;
                const conf = configuration.concepts_arborescence.ordre;

                if (splitPointIndex !== -1) {
                    // Sort all the concepts by configurations
                    const conceptArray = nodes.slice(0, splitPointIndex);
                    conceptArray.sort((a, b) => StoreConfiguration.compareByConfig(a, b, conf, lang, initialKey));
                    // Sort all the individuals by configurations
                    const individualArray = nodes.slice(splitPointIndex, nodes.length + 1);
                    individualArray.sort((a, b) => StoreConfiguration.compareByConfig(a, b, conf, lang, initialKey));

                    nodes = conceptArray.concat(individualArray);
                } else {
                    // Sort all the concepts by configurations
                    nodes.sort((a, b) => StoreConfiguration.compareByConfig(a, b, conf, lang, initialKey));
                }
            }
        }

        return nodes;
    }

    /**
     * Format concept props to facilitate the retrieving of data.
     * @param props
     */
    formatConceptProps(props) {

        let valuesFormatted = {};

        props.forEach((value) => {
            let literalValue;
            if (value.literals && value.literals.length > 0 && value.literals[0].value !== null) {
                if (Array.isArray(value.literals[0].value)) {
                    literalValue = value.literals[0].value; // Garde le tableau tel quel
                } else {
                    literalValue = [value.literals[0].value]; // Convertit la valeur en tableau
                }
            } else {
                literalValue = value.value; //A supprimer dans une prochaine release sur demande de l'ANS (la partie qui est dans "value.value").
            }

            valuesFormatted[value.key] = {
                ...valuesFormatted[value.key],
                ...{
                    [value.lang]: {
                        "value": literalValue,
                        "valueUris": value.valueUris
                    }
                }
            }
        });

        return valuesFormatted;
    }

    /**
     * Get all root concepts of a specific terminology.
     */
    async getRootConcepts(terminologyId, childrenLimit, isBrowserSnomedLicence, lang) {
        let endpoint = '/api/concepts/roots';
        let params = {
            'size': childrenLimit,
            'terminologyId': terminologyId,
            'isBrowserSnomedLicence': isBrowserSnomedLicence,
            'lang': lang,
        };

        return await axios.get(
            Vue.prototype.$searchResultManager.middlewareBaseUrl + endpoint,
            { params: params, headers: Store.buildAuthorizationHeader() }
        ).then((response) => {
            // Sort results ascending depending on the "order" attribute and map to retrieve only necessary fields
            return response.data
                .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
                .map((rootConcept) => {
                    return {
                        id: rootConcept.id,
                        parentId: "",
                        class: rootConcept.class || true,
                        ...(rootConcept.props && { props: this.formatConceptProps(rootConcept.props) }),
                        ...(!rootConcept.leaf && { children: [] })
                    };
                });
        });
    }

    /**
     * Get child concepts of a parent concept.
     */
    async getChildConcepts(conceptsId, terminologyId, childrenLimit, isBrowserSnomedLicence, lang) {
        let endpoint = '/api/concepts/child';
        let params = {
            'size': childrenLimit,
            'terminologyId': terminologyId,
            'conceptId': conceptsId.join(','),
            'lang': lang,
            'isBrowserSnomedLicence': isBrowserSnomedLicence
        };

        return await axios.get(
            Vue.prototype.$searchResultManager.middlewareBaseUrl + endpoint,
            { params: params, headers: Store.buildAuthorizationHeader() }
        ).then(response => { return response });
    }
}

export default new TreeUtils();